import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { jdGreen } from '../themes';
import { GlobalStyles } from '../GlobalStyles/GlobalStyles';
import CssBaseline from '@mui/material/CssBaseline';
/**
 * Read more about why these value are stored in the mui docs:
 * @link https://v5.mui.com/material-ui/customization/how-to-customize/#4-global-css-override
 */
const globalStyles = _jsx(GlobalStyles, {});
const globalStylesWithoutFonts = _jsx(GlobalStyles, { excludeFontStyles: true });
export const ThemeProvider = ({ children, baseline = true, includeFonts = true, theme = jdGreen, ...props }) => {
    return (_jsx(MuiThemeProvider, { theme: theme, ...props, children: _jsxs("div", { "data-fuel-theme": theme.name === 'jdBlack' ? 'fuel-jd-black' : 'fuel-jd-green', children: [baseline && _jsx(CssBaseline, {}), includeFonts ? globalStyles : globalStylesWithoutFonts, children] }) }));
};
